import GLOBAL_VALUES from '@utils/global-values.js'

export const roles = {
    AccessTeamBasics: [
        GLOBAL_VALUES.ROLES.OWNER,
        GLOBAL_VALUES.ROLES.MANAGER,
        GLOBAL_VALUES.ROLES.COORDINATOR,
        GLOBAL_VALUES.ROLES.TEACHER,
        GLOBAL_VALUES.ROLES.SECRETARY,
        GLOBAL_VALUES.ROLES.STAFF,
        GLOBAL_VALUES.ROLES.CUSTOMER_SUCCESS,
        GLOBAL_VALUES.ROLES.ADMIN,
        GLOBAL_VALUES.ROLES.SUPPORT,
    ],
    PoolAndTeam: [
        GLOBAL_VALUES.ROLES.OWNER,
        GLOBAL_VALUES.ROLES.MANAGER,
        GLOBAL_VALUES.ROLES.COORDINATOR,
        GLOBAL_VALUES.ROLES.ASSESSOR,
        GLOBAL_VALUES.ROLES.CUSTOMER_SUCCESS,
        GLOBAL_VALUES.ROLES.STAFF,
        GLOBAL_VALUES.ROLES.ADMIN,
        GLOBAL_VALUES.ROLES.SUPPORT,
    ],
    ConfigurationBasics: [
        GLOBAL_VALUES.ROLES.ADMIN,
        GLOBAL_VALUES.ROLES.STAFF,
        GLOBAL_VALUES.ROLES.SUPPORT,
        GLOBAL_VALUES.ROLES.DEVELOPER,
        GLOBAL_VALUES.ROLES.MARKETING,
    ],
    PlansCollaborators: [GLOBAL_VALUES.ROLES.STAFF, GLOBAL_VALUES.ROLES.ADMIN],
    isPublic: ['isPublic'],
    isLogged: [
        GLOBAL_VALUES.ROLES.OWNER,
        GLOBAL_VALUES.ROLES.MANAGER,
        GLOBAL_VALUES.ROLES.COORDINATOR,
        GLOBAL_VALUES.ROLES.TEACHER,
        GLOBAL_VALUES.ROLES.SECRETARY,
        GLOBAL_VALUES.ROLES.ASSESSOR,
        GLOBAL_VALUES.ROLES.CUSTOMER_SUCCESS,
        GLOBAL_VALUES.ROLES.ADMIN,
        GLOBAL_VALUES.ROLES.SUPPORT,
        GLOBAL_VALUES.ROLES.EDUCATOR,
        GLOBAL_VALUES.ROLES.STAFF,
    ],
    Pedagogic: [
        GLOBAL_VALUES.ROLES.EDUCATOR,
        GLOBAL_VALUES.ROLES.STAFF,
        GLOBAL_VALUES.ROLES.ADMIN,
        GLOBAL_VALUES.ROLES.SUPPORT,
        GLOBAL_VALUES.ROLES.DEVELOPER,
    ],
    OccupancyMap: [
        GLOBAL_VALUES.ROLES.OWNER,
        GLOBAL_VALUES.ROLES.MANAGER,
        GLOBAL_VALUES.ROLES.COORDINATOR,
        GLOBAL_VALUES.ROLES.TEACHER,
        GLOBAL_VALUES.ROLES.SECRETARY,
        GLOBAL_VALUES.ROLES.ASSESSOR,
        GLOBAL_VALUES.ROLES.CUSTOMER_SUCCESS,
        GLOBAL_VALUES.ROLES.ADMIN,
        GLOBAL_VALUES.ROLES.SUPPORT,
        GLOBAL_VALUES.ROLES.EDUCATOR,
        GLOBAL_VALUES.ROLES.STAFF,
    ],
}
